import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-background-100">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            <div>
              <h3 className="font-heading text-xl font-bold text-background-50 mb-4">
                黑料中文网
              </h3>
              <p className="text-sm text-foreground-400 leading-relaxed">
                专注于娱乐圈黑料、明星爆料、网红内幕的中文资讯平台。每日更新独家爆料，让你第一时间掌握圈内动态。
              </p>
            </div>

            <div>
              <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
                内容分类
              </h4>
              <ul className="flex flex-col gap-2">
                {categories.map((cat) => (
                  <li key={cat.slug}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
                快速链接
              </h4>
              <ul className="flex flex-col gap-2">
                <li>
                  <Link to="/" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">
                    首页
                  </Link>
                </li>
                <li>
                  <Link to="/about" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">
                    关于我们
                  </Link>
                </li>
                <li>
                  <a href="#contact" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">
                    联系我们
                  </a>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
                关注我们
              </h4>
              <p className="text-sm text-foreground-400 mb-3">
                关注黑料中文网，获取最新娱乐爆料资讯
              </p>
              <div className="flex gap-3">
                <a href="#" className="w-10 h-10 flex items-center justify-center rounded-lg bg-foreground-800 hover:bg-primary-600 text-foreground-300 hover:text-background-50 transition-colors cursor-pointer" aria-label="微博">
                  <i className="ri-weibo-line text-lg"></i>
                </a>
                <a href="#" className="w-10 h-10 flex items-center justify-center rounded-lg bg-foreground-800 hover:bg-primary-600 text-foreground-300 hover:text-background-50 transition-colors cursor-pointer" aria-label="微信">
                  <i className="ri-wechat-line text-lg"></i>
                </a>
                <a href="#" className="w-10 h-10 flex items-center justify-center rounded-lg bg-foreground-800 hover:bg-primary-600 text-foreground-300 hover:text-background-50 transition-colors cursor-pointer" aria-label="抖音">
                  <i className="ri-tiktok-line text-lg"></i>
                </a>
              </div>
            </div>
          </div>

          <div className="border-t border-foreground-800 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-500">
              &copy; 2026 黑料中文网 - 版权所有。本网站内容仅供娱乐参考，如有不实之处请联系我们更正。
            </p>
            <div className="flex gap-6">
              <a href="#" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors cursor-pointer">隐私政策</a>
              <a href="#" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors cursor-pointer">用户协议</a>
              <a href="#" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors cursor-pointer">免责声明</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}